// Who may turn on admin mode.
//
// "admin" is the kast-dev.net pool-wide Cognito group, managed at
// kast-dev.net/admin/users (Waypoint also accepts its own "waypoint" group;
// homepage has no app-scoped one). Only id tokens carry cognito:groups.
// Matched exactly, by the shared module's hasGroup, as the API compares it
// (api-rs/src/auth.rs ADMIN_GROUP): a user in "Admin" is not an admin.
//
// This decides what UI is offered, nothing more. The API checks the same
// group in the token for the visitor log and the deploy times
// (api-rs/src/auth.rs) and for the read and edit access to other people's
// items that admin mode exposes (api-rs/src/services/access.rs).

export const ADMIN_GROUPS: readonly string[] = ["admin"];
